/*
  Pick a pearl, the popup. Inform and ask first ("Yes, pick my pearl" / "No thanks"), then first
  name and email with the fine print (the join: wx-pearl-core.js), then the optional phone, then the
  game page in the same tab with ?t=token, plus where they were, so the result can apply the code
  and send them back.
  Shown to US visitors only (the section renders nothing elsewhere, so the international 15%
  popup keeps running there). Ported from landing-pages/popup/pick-a-pearl/card.html.
*/
(function () {
  var pop = document.getElementById("wxp-pop");
  var core = window.wxPearlCore;
  if (!pop || !core) return;
  var $ = function (s) { return document.getElementById(s); };
  var tab = $("wxp-tab"), product = pop.dataset.product || "";
  var DELAY = Number(pop.dataset.delay || 10) * 1000, AGAIN = Number(pop.dataset.againHours || 12) / 24;
  var name = "", email = "", token = core.get("wx_pearl_t") || "";
  var preview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== "main");

  function days(k) { var t = Number(core.get(k) || 0); return t ? (Date.now() - t) / 86400000 : Infinity; }
  function step(s) {
    pop.querySelectorAll(".wxp__step").forEach(function (e) { e.hidden = e.dataset.s !== s; });
    core.collect("step", { step: { ask: 0, email: 1, phone: 2 }[s] });
  }
  function open() {
    pop.hidden = false; tab.hidden = true; document.documentElement.classList.add("wxp-lock");
    core.set("wx_pearl_seen", String(Date.now())); core.collect("viewed");
  }
  function close() {
    pop.hidden = true; tab.hidden = false; document.documentElement.classList.remove("wxp-lock");
    core.set("wx_pearl_closed", String(Date.now())); core.collect("closed");
  }
  function msg(id, t) { $(id).hidden = !t; $(id).textContent = t || ""; }

  function gameUrl() {
    var u = core.cfg.game + "?t=" + encodeURIComponent(token);
    if (product) u += "&from=" + encodeURIComponent(location.pathname) + "&back=" + encodeURIComponent(product);
    return u;
  }

  /* someone who already joined never sees the ask again: the tab takes them straight to the game */
  if (token) {
    tab.textContent = "Your pearl";
    tab.hidden = false;
    tab.onclick = function () { core.collect("teaser"); location.href = gameUrl(); };
    return;
  }

  $("wxp-x").onclick = close; $("wxp-no").onclick = close;
  pop.addEventListener("click", function (e) { if (e.target === pop) close(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !pop.hidden) close(); });
  tab.onclick = function () { core.collect("teaser"); step("ask"); open(); };
  $("wxp-yes").onclick = function () { step("email"); setTimeout(function () { $("wxp-fname").focus(); }, 50); };

  $("wxp-emailF").addEventListener("submit", function (e) {
    e.preventDefault();
    var n = $("wxp-fname").value.trim(), v = $("wxp-email").value.trim();
    var bad = !n ? "Add your first name." : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "Add an email address we can send your prize to." : "";
    msg("wxp-msg", bad); if (bad) return;
    var btn = e.target.querySelector("button[type=submit]"); btn.disabled = true;
    name = n.replace(/[<>&"]/g, "").slice(0, 24); email = v;
    core.join({ email: email, first_name: name, from: product ? location.pathname : "" }).then(function (j) {
      btn.disabled = false; token = j.token;
      if (j.picked) { location.href = gameUrl(); return; }      // played before: straight to their result
      step("phone");
    }).catch(function (err) { btn.disabled = false; msg("wxp-msg", err.message); });
  });

  /* US numbers: ten digits get +1. Klaviyo only takes E.164. */
  function e164(p) {
    var d = p.replace(/[^\d+]/g, "");
    if (/^\+\d{8,15}$/.test(d)) return d;
    d = d.replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d[0] === "1") return "+" + d;
    return "";
  }
  $("wxp-phoneF").addEventListener("submit", function (e) {
    e.preventDefault();
    var raw = $("wxp-phone").value.trim();
    if (!raw) { location.href = gameUrl(); return; }
    var p = e164(raw);
    if (!p) { msg("wxp-msg2", "Add a US number, for example (310) 555-0134."); return; }
    var btn = e.target.querySelector("button[type=submit]"); btn.disabled = true;
    core.addPhone(email, p, $("wxp-sms").checked)
      .catch(function () { /* the email is in; a phone that fails never blocks the game */ })
      .then(function () { location.href = gameUrl(); });
  });
  $("wxp-skip").onclick = function () { location.href = gameUrl(); };

  /* when it opens: ?pearl=email|phone for review links; otherwise after DELAY, unless closed within
     AGAIN (12 hours, Lau 4 Nov 2026) or Klaviyo already knows this browser (existing subscribers get the tab, not the ask) */
  var at = new URLSearchParams(location.search).get("pearl");
  if (at === "email" || at === "phone") { step(at); open(); return; }
  if (days("wx_pearl_closed") < AGAIN) { tab.hidden = false; return; }
  step("ask");
  setTimeout(function () {
    var known = window.klaviyo && typeof klaviyo.isIdentified === "function" ? Promise.resolve(klaviyo.isIdentified()).catch(function () { return false; }) : Promise.resolve(false);
    known.then(function (k) { if (k === true && !preview) tab.hidden = false; else open(); });
  }, preview ? 1500 : DELAY);
})();
